import { useContext } from "react";
import AuthContext from "../../../context/AuthContext";
import { Spinner } from "../../../components";
import { AdditionalDocumentsAdmin } from "./AdditionalDocumentsAdmin";
import { AdditionalDocumentsClient } from "./AdditionalDocumentsClient";

export const AdditionalDocumentsPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);
  const content =
    idRole === 3 ? <AdditionalDocumentsClient /> : <AdditionalDocumentsAdmin />;
  return isLoading ? <Spinner /> : content;
};
